// api/carrierAuth.js
import axios from '@/api'

/**
 * 运营商一键登录
 * @param {Object} data - 登录参数
 * @param {string} data.carrierToken - 运营商认证token
 * @param {string} data.carrierType - 运营商类型：CMCC-中国移动，CUCC-中国联通，CTCC-中国电信
 * @param {string} [data.encryptedPhone] - 加密的手机号数据（可选）
 * @param {string} [data.extraData] - 其他扩展数据（可选）
 */
export const carrierLogin = (data) => {
  return axios.post('/auth/carrier/login', data)
    .then(res => res.data)
}
